import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { MotivoPerda } from '../models/motivo-perda';

@Injectable({
  providedIn: 'root'
})
export class MotivoPerdaService {

  constructor(private http: HttpClient) {

  }

  consultar(grupo?) {
    let parametros = new HttpParams();

    if (grupo != null && grupo != undefined) {
      parametros = parametros.set('grupo', grupo);
    }

    return this.http.get<MotivoPerda[]>(globals.apiUrl + '/api/MotivoPerda/Lista',
      { params: parametros }
    );
  }

  consultarComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, grupoSelecionado?) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (grupoSelecionado != null && grupoSelecionado != undefined) {
      parametros = parametros.set('grupo', grupoSelecionado);
    }

    return this.http.get<any>(globals.apiUrl + '/api/MotivoPerda/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/MotivoPerda/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(motivoPerda: MotivoPerda) {
    return this.http.post(globals.apiUrl + '/api/MotivoPerda/Salvar', motivoPerda,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/MotivoPerda/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
